import { Autocomplete, TextField, CircularProgress } from '@mui/material';
import { useQuickBooksCustomerSelection } from './hooks/use-quickBooks-customer-selection';

export const QuickBooksCustomersDropdown: React.FC = () => {
  const { selectedCustomer, quickBooksCustomers, isFetching, handleInputChange, handleCustomerChange } =
    useQuickBooksCustomerSelection();

  return (
    <Autocomplete
      options={quickBooksCustomers ?? []}
      getOptionLabel={(option) => `${option.id}  ${option.name}`}
      value={selectedCustomer}
      onChange={handleCustomerChange}
      onInputChange={handleInputChange}
      renderInput={(params) => (
        <TextField
          {...params}
          label="QB ERP ID"
          placeholder='Select QuickBooks Customer'
          slotProps={{
            ...params.slotProps,

            input: {
              ...params.slotProps.input,
              endAdornment: (
                <>
                  {isFetching && <CircularProgress color="inherit" size={20} />}
                  {params.slotProps.input.endAdornment}
                </>
              ),
            },

            inputLabel: {
              shrink: true,
            }
          }} />
      )}
    />
  );
};
